var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"windows-button button"},[_c('img',{attrs:{"src":require("../../public/image/ic_button_apple@2x.png"),"alt":"Apple icon"}}),_c('span',{staticClass:"button-text"},[_vm._v(_vm._s(_vm.$t(_vm.windows_text)))])])}
var staticRenderFns = []

export { render, staticRenderFns }